import { CommonModule } from '@angular/common';
import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { SafeHtml } from '@angular/platform-browser';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'tm-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        MatDialogModule,
        TranslateModule
    ]
})
export class ConfirmDialogComponent {

  get message() {
    return typeof this.data.message === 'string' ? this._translate.instant(this.data.message) : this.data.message;
  }

  constructor(
    private _translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogOptions
  ) { }

}

export interface ConfirmDialogOptions {
  icon?: string;
  title?: string;
  cancelBtnLabel?: string;
  confirmBtnLabel?: string;
  confirmBtnType?: 'default' | 'primary' | 'secondary' | 'warning' | 'danger';
  message: string | SafeHtml;
}